import React from "react";

import { StyledSVG } from "../StyledIcon";

export const MinusIcon = props => {
  const { iconColor, iconWidth, iconHeight } = props;

  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_2142_41090)">
        <path
          d="M16.5078 9L1.50781 9"
          stroke={iconColor}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          vectorEffect="non-scaling-stroke"
        />
      </g>
      <defs>
        <clipPath id="clip0_2142_41090">
          <rect width="18" height="18" fill="white" transform="translate(0.0078125)" />
        </clipPath>
      </defs>
    </StyledSVG>
  );
};
